import React, { PureComponent } from 'react'
import { Row, Col, Tab, Tabs, Button } from 'react-bootstrap'
import Tab1 from './Tabs/Tab1'
import Tab2 from './Tabs/Tab2'
import Tab3 from './Tabs/Tab3'
import Step3 from './Step3/Step3'

class purchaseUaCDossier extends PureComponent {
  render () {
    return (
      <Col sm={12} className="purchase-uac-dossier-wrapper dossier">
        <Row className="time-line-button">
          <Col sm={7} className="time-line">
            <div className="step-wrapper">
              <div className="step active">
                <span className="step-number">1</span>
                <span className="step-name">Datos expediente</span>
              </div>
            </div>
            <div className="step-wrapper">
              <div className="step">
                <span className="step-number">2</span>
                <span className="step-name">Tasación</span>
              </div>
            </div>
            <div className="step-wrapper">
              <div className="step">
                <span className="step-number">3</span>
                <span className="step-name">Gestión de Documentos</span>
              </div>
            </div>
          </Col>
          <Col sm={2} smPush={2} className="text-right btn-timeline">
            <Button className="btn-standard btn-continue">
              Documentación
            </Button>
          </Col>
        </Row>
        <Row className="band-user">
          <Col sm={3} className="band-icon-item">
            <i className="ico-user" />
            <div className="text-band">
              <span className="first">Nombre del gestor:</span>
              <span className="second">Nombre del gestor</span>
            </div>
          </Col>
          <Col sm={3} className="band-icon-item">
            <i className="ico-user" />
            <div className="text-band">
              <span className="first">Nombre del proveedor:</span>
              <span className="second">Nombre del proveedor</span>
            </div>
          </Col>
          <Col sm={3} className="band-icon-item">
            <i className="ico-car" />
            <div className="text-band">
              <span className="first">Marca:</span>
              <span className="second">Marca</span>
            </div>
          </Col>
          <Col sm={3} className="band-icon-item">
            <i className="ico-car" />
            <div className="text-band">
              <span className="first">Modelo:</span>
              <span className="second">Modelo</span>
            </div>
          </Col>
        </Row>
        <Row className="tabs-wrapper">
          <Tabs id="purchase-vn-dossier-tabs" defaultActiveKey={1}>
            <Tab eventKey={1} title='Expediente'>
              <Tab1/>
            </Tab>
            <Tab eventKey={2} title='Propietario'>
              <Tab2/>
            </Tab>
            <Tab eventKey={3} title='Vehículo'>
              <Tab3/>
            </Tab>
          </Tabs>
        </Row>
        <Step3/>
      </Col>
    )
  }
}

export default purchaseUaCDossier
